/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCouponUsageSummary } from './BaseCouponUsageSummary';
const CourseCouponUsageSummaryParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('course')],
]), BaseCouponUsageSummary);
export class CourseCouponUsageSummary extends BaseCouponUsageSummary {
    static decode(input) {
        return CourseCouponUsageSummaryParser.decode(input).map(res => new CourseCouponUsageSummary(res));
    }
    static unsafeDecode(input) {
        return CourseCouponUsageSummary.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseCouponUsageSummaryParser.encode(data);
    }
    static schema() {
        return CourseCouponUsageSummaryParser.schema();
    }
}
